var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1C18.0751 1 23 5.92486 23 12C23 17.4903 18.9775 22.0412 13.7188 22.8664V15.1797H16.2818L16.7695 12H13.7188V9.9375C13.7188 9.0676 14.145 8.21875 15.5114 8.21875H16.8984V5.51172C16.8984 5.51172 15.9344 5.34723 14.8873 5.30611C14.7378 5.30023 14.5865 5.29688 14.4361 5.29688C11.9235 5.29688 10.2812 6.81969 10.2812 9.57656V12H7.48828V15.1797H10.2812V22.8664C5.02252 22.0412 1 17.4903 1 12C1 5.92486 5.92486 1 12 1Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebookIcon.b2023ed0664f71c26d5f7e5aae1a1eac.svg";
export { ForwardRef as ReactComponent };